// src/features/records/services/utils/auth.js

import { auth } from '../../../../firebase';

export function requireUser() {
  const user = auth.currentUser;
  if (!user) {
    const error = new Error('User must be authenticated');
    error.code = 'unauthenticated';
    throw error;
  }
  return user;
}

export function requireUid() {
  return requireUser().uid;
}

export function normalizeCallableError(error, fallbackMessage = 'An unexpected error occurred.', fallbackCode = 'internal') {
  if (error && typeof error.code === 'string') {
    if (error.code.startsWith('functions/')) {
      error.code = error.code.slice('functions/'.length);
    }
    return error;
  }

  const wrapped = new Error(fallbackMessage);
  wrapped.code = fallbackCode;
  wrapped.originalError = error;
  return wrapped;
}
